export function formatString(value: string) {
    return value ? value : '-';
}